<div class="grid" [ngClass]="navBarClass">
  <div class="logo" [ngClass]="logoClass">
    <img [src]="navBarlogo" alt="logoNavBAr">
  </div>
  <div [ngClass]="motdClass" class="motd-nb">
    <h3 [innerHTML]="getUserMessageOfTheDay()"></h3>
  </div>
  <div id="navBarButtons" class="col-2 flex justify-content-end">
    <div *ngIf="isAdminLog || isAdminNumen" [ngClass]="{'col-2': mopAvailable, 'col-3': !mopAvailable}" class="div-button without-border-radius">
      <button  pButton type="button" [icon]="'fa fa-newspaper-o'" [iconPos]="'left'" (click)="openActionLogging()"
               class="p-button-secondary navbarButton"></button>
    </div>
    <div class="div-button without-border-radius" [ngClass]="{'col-2': mopAvailable, 'col-3': !mopAvailable}">
      <button pButton type="button" [icon]="'fa fa-print'" [iconPos]="'left'" (click)="openDownloadVirtualPrinter()"
              class="p-button-warning navbarButton"></button>
    </div>
    <div *ngIf="mopAvailable" class="col-2 div-button without-border-radius">
      <button  pButton type="button" [icon]="'fa fa-question-circle'" [iconPos]="'left'" (click)="showMop()"
              class="p-button-secondary navbarButton"></button>
    </div>
    <div class="div-button without-border-radius" [ngClass]="{'col-2': mopAvailable, 'col-3': !mopAvailable}">
      <button pButton type="button" [icon]="'fa fa-cogs'" [iconPos]="'left'" (click)="openParamDialog()"
              class="p-button-warning navbarButton"></button>
    </div>
    <div class="div-button" [ngClass]="{'col-2': mopAvailable, 'col-3': !mopAvailable}">
      <button pButton type="button" [icon]="'fa fa-sign-out'" [iconPos]="'left'" id="logoutButton" (click)="logout()"
              class="p-button-danger navbarButton"></button>
    </div>
  </div>
</div>
<!--Visualization modal-->
<div class="mop-display-modal" *ngIf="openHelp">
  <p-dialog  [(visible)]="openHelp"
             [header]="'COMMON.MOP' | translate" (onHide)="freeDocMemory(mopFile)"
             [draggable]="true"
             [closable]="true"
             [modal]="true" [closeOnEscape]="true">
    <object *ngIf="openHelp && !msBrowsers" [data]="mopFile| safeObjUrl" type="application/pdf" width="100%" height="100%"></object>
    <!-- <a href="pdfToDisplay">Download PDF</a>-->
  </p-dialog>
</div>
